import {IGameFilterDefinition} from "../filters-definitions/game-filter-definition.interface";
import {VendorFilterDefinition} from "../filters-definitions/vendor/vendor.filter-definition";
import {FilterCategoryDefinitionBase} from "./filter-category-definition-base";
import {CategoryDefinitionId} from "./filter-category-definition.interface";

export class GameVendorFiltersCategoryDefinition extends FilterCategoryDefinitionBase {

    get id(): CategoryDefinitionId {
        return 'vendors';
    }

    get title(): string{
        return this.services.translation.translate('Games Studio');
    }

    protected _loadAvailableFilters(): IGameFilterDefinition[] {
        return [
            new VendorFilterDefinition('vendor_888','888', this.services.translation.translate('EXCLUSIVE')),
            new VendorFilterDefinition('vendor_netent', 'NetEnt', "NETENT"),
            new VendorFilterDefinition('vendor_playngo', 'play n go', `Play'n GO`),
            new VendorFilterDefinition('vendor_redtiger', 'Red Tiger'),
            new VendorFilterDefinition('vendor_quickspin', 'Quickspin'),
            new VendorFilterDefinition('vendor_yggdrasil', 'Yggdrasil'),
            new VendorFilterDefinition('vendor_merkur', 'Merkur'),
            new VendorFilterDefinition('vendor_gamomat', 'Gamomat'),
            new VendorFilterDefinition('vendor_egt', 'EGT'),
            new VendorFilterDefinition('vendor_mga', 'MGA'),
            new VendorFilterDefinition('vendor_playtech','PlayTech', 'PLAYTECH'),
            new VendorFilterDefinition('vendor_pragmatic', 'Pragmatic'),
            new VendorFilterDefinition('vendor_blueprint', 'Blueprint'),
            new VendorFilterDefinition('vendor_evolution', 'Evolution'),
            new VendorFilterDefinition('vendor_light_and_wonder', 'LNW'),
            new VendorFilterDefinition('vendor_igt', 'IGT'),
            new VendorFilterDefinition('vendor_h5', 'H5'),
            new VendorFilterDefinition('vendor_everi', 'Everi')
        ];
    }


}






